import React, { useRef, useState } from "react";
import { Page } from "react-pdf";
import { useAtomValue } from "jotai";
import { zoomVisorFormularioAtom } from "../../../../VisorFormularioStorage";
import styled from "@emotion/styled";
import { ListaControlesPdf } from "../ListaControlesPdf";

const PaginaPdf = ({ numeroPagina, pageWidth }) => {
	const zoom = useAtomValue(zoomVisorFormularioAtom);
	const [canvasHeight, setCanvasHeight] = useState(null);
	const innerRef = useRef(null);

	const onRenderSuccess = () => {
		if (innerRef.current && !canvasHeight) {
			const canvas = innerRef.current.querySelector('canvas');
			if (canvas) setCanvasHeight(canvas.offsetHeight);
		}
	};

	if (pageWidth) {
		// fitToWidth mode: canvas renders ONCE at container width.
		// Zoom via CSS transform — instant, no canvas re-render.
		const approxHeight = pageWidth * 1.414;
		const outerHeight = (canvasHeight ?? approxHeight) * zoom;

		return (
			<React.Fragment>
				<div style={{ position: 'relative', height: outerHeight, overflow: 'visible' }}>
					<div
						ref={innerRef}
						style={{
							transform: `scale(${zoom})`,
							transformOrigin: 'top left',
							display: 'inline-block',
						}}
					>
						<Page
							pageNumber={numeroPagina}
							loading={null}
							width={pageWidth}
							onRenderSuccess={onRenderSuccess}
						/>
						<ListaControlesPdf pageNumber={numeroPagina} />
					</div>
				</div>
				<SeparadorPaginas />
			</React.Fragment>
		);
	}

	// Regular mode (form documents): scale prop for zoom
	return (
		<React.Fragment>
			<div style={{ position: "relative" }}>
				<Page pageNumber={numeroPagina} loading={null} scale={zoom} />
				<ListaControlesPdf pageNumber={numeroPagina} />
			</div>
			<SeparadorPaginas />
		</React.Fragment>
	);
};

const SeparadorPaginas = () => {
	return (
		<div style={{ width: "100%", position: "relative" }}>
			<div style={{ height: "2em" }}></div>
		</div>
	);
};

export default PaginaPdf;
